const global = window;

inputs.fn.state = {
    data: {
        "AU": [
        ['', ''],
        ["Australian Capital Territory", "Territoire de la capitale australienne"],
        ["New South Wales", "Nouvelle-Galles du Sud"],
        ["Northern Territory", "Territoire du Nord"],
        ["Queensland", "Queensland"],
        ["South Australia", "Australie-Méridionale"],
        ["Tasmania", "Tasmanie"],
        ["Victoria", "Victoria"],
        ["Western Australia", "Australie-Occidentale"]
        ],
        "BR": [
        ['', ''],
        ["AC", "Acre"],
        ["AL", "Alagoas"],
        ["AP", "Amapá"],
        ["AM", "Amazonas"],
        ["BA", "Bahia"],
        ["CE", "Ceará"],
        ["DF", "District fédéral"],
        ["ES", "Espírito Santo"],
        ["GO", "Goiás"],
        ["MA", "Maranhão"],
        ["MT", "Mato Grosso"],
        ["MS", "Mato Grosso do Sul"],
        ["MG", "Minas Gerais"],
        ["PA", "Pará"],
        ["PB", "Paraíba"],
        ["PR", "Paraná"],
        ["PE", "Pernambuco"],
        ["PI", "Piauí"],
        ["RJ", "Rio de Janeiro"],
        ["RN", "Rio Grande do Norte"],
        ["RS", "Rio Grande do Sul"],
        ["RO", "Rondônia"],
        ["RR", "Roraima"],
        ["SC", "Santa Catarina"],
        ["SP", "São Paulo"],
        ["SE", "Sergipe"],
        ["TO", "Tocantins"]
        ],
        "CA": [
        ['', ''],
        ["Quebec", "Québec", '', 'Province'],
        ["Ontario", "Ontario", '', 'Province'],
        ["British Columbia", "Colombie-Britannique", '', 'Province'],
        ["Alberta", "Alberta", '', 'Province'],
        ["Manitoba", "Manitoba", '', 'Province'],
        ["New Brunswick", "Nouveau-Brunswick", '', 'Province'],
        ["Newfoundland", "Terre-Neuve-et-Labrador", '', 'Province'],
        ["Nova Scotia", "Nouvelle-Écosse", '', 'Province'],
        ["Prince Edward Island", "Île-du-Prince-Édouard", '', 'Province'],
        ["Saskatchewan", "Saskatchewan", '', 'Province'],
        ["Northwest Territories", "Territoires du Nord-Ouest", '', 'Territoire'],
        ["Nunavut", "Nunavut", '', 'Territoire'],
        ["Yukon", "Yukon", '', 'Territoire']
        ],
        "FR": [
        ['', ''],
        ["Ain", "Ain"],
        ["Aisne", "Aisne"],
        ["Allier", "Allier"],
        ["Alpes-de-Haute-Provence", "Alpes-de-Haute-Provence"],
        ["Hautes-Alpes", "Hautes-Alpes"],
        ["Alpes-Maritimes", "Alpes-Maritimes"],
        ["Ardèche", "Ardèche"],
        ["Ardennes", "Ardennes"],
        ["Ariège", "Ariège"],
        ["Aube", "Aube"],
        ["Aude", "Aude"],
        ["Aveyron", "Aveyron"],
        ["Bouches-du-Rhône", "Bouches-du-Rhône"],
        ["Calvados", "Calvados"],
        ["Cantal", "Cantal"],
        ["Charente", "Charente"],
        ["Charente-Maritime", "Charente-Maritime"],
        ["Cher", "Cher"],
        ["Corrèze", "Corrèze"],
        ["Corse-du-Sud", "Corse-du-Sud"],
        ["Haute-Corse", "Haute-Corse"],
        ["Côte-d'Or", "Côte-d'Or"],
        ["Côtes-d'Armor", "Côtes-d'Armor"],
        ["Creuse", "Creuse"],
        ["Dordogne", "Dordogne"],
        ["Doubs", "Doubs"],
        ["Drôme", "Drôme"],
        ["Eure", "Eure"],
        ["Eure-et-Loir", "Eure-et-Loir"],
        ["Finistère", "Finistère"],
        ["Gard", "Gard"],
        ["Haute-Garonne", "Haute-Garonne"],
        ["Gers", "Gers"],
        ["Gironde", "Gironde"],
        ["Hérault", "Hérault"],
        ["Ille-et-Vilaine", "Ille-et-Vilaine"],
        ["Indre", "Indre"],
        ["Indre-et-Loire", "Indre-et-Loire"],
        ["Isère", "Isère"],
        ["Jura", "Jura"],
        ["Landes", "Landes"],
        ["Loir-et-Cher", "Loir-et-Cher"],
        ["Loire", "Loire"],
        ["Haute-Loire", "Haute-Loire"],
        ["Loire-Atlantique", "Loire-Atlantique"],
        ["Loiret", "Loiret"],
        ["Lot", "Lot"],
        ["Lot-et-Garonne", "Lot-et-Garonne"],
        ["Lozère", "Lozère"],
        ["Maine-et-Loire", "Maine-et-Loire"],
        ["Manche", "Manche"],
        ["Marne", "Marne"],
        ["Haute-Marne", "Haute-Marne"],
        ["Mayenne", "Mayenne"],
        ["Meurthe-et-Moselle", "Meurthe-et-Moselle"],
        ["Meuse", "Meuse"],
        ["Morbihan", "Morbihan"],
        ["Moselle", "Moselle"],
        ["Nièvre", "Nièvre"],
        ["Nord", "Nord"],
        ["Oise", "Oise"],
        ["Orne", "Orne"],
        ["Pas-de-Calais", "Pas-de-Calais"],
        ["Puy-de-Dôme", "Puy-de-Dôme"],
        ["Pyrénées-Atlantiques", "Pyrénées-Atlantiques"],
        ["Hautes-Pyrénées", "Hautes-Pyrénées"],
        ["Pyrénées-Orientales", "Pyrénées-Orientales"],
        ["Bas-Rhin", "Bas-Rhin"],
        ["Haut-Rhin", "Haut-Rhin"],
        ["Rhône", "Rhône"],
        ["Haute-Saône", "Haute-Saône"],
        ["Saône-et-Loire", "Saône-et-Loire"],
        ["Sarthe", "Sarthe"],
        ["Savoie", "Savoie"],
        ["Haute-Savoie", "Haute-Savoie"],
        ["Paris", "Paris"],
        ["Seine-Maritime", "Seine-Maritime"],
        ["Seine-et-Marne", "Seine-et-Marne"],
        ["Yvelines", "Yvelines"],
        ["Deux-Sèvres", "Deux-Sèvres"],
        ["Somme", "Somme"],
        ["Tarn", "Tarn"],
        ["Tarn-et-Garonne", "Tarn-et-Garonne"],
        ["Var", "Var"],
        ["Vaucluse", "Vaucluse"],
        ["Vendée", "Vendée"],
        ["Vienne", "Vienne"],
        ["Haute-Vienne", "Haute-Vienne"],
        ["Vosges", "Vosges"],
        ["Yonne", "Yonne"],
        ["Territoire de Belfort", "Territoire de Belfort"],
        ["Essonne", "Essonne"],
        ["Hauts-de-Seine", "Hauts-de-Seine"],
        ["Seine-Saint-Denis", "Seine-Saint-Denis"],
        ["Val-de-Marne", "Val-de-Marne"],
        ["Val-d'Oise", "Val-d'Oise"],
        ["Guadeloupe", "Guadeloupe"],
        ["Martinique", "Martinique"],
        ["Guyane", "Guyane"],
        ["La Réunion", "La Réunion"],
        ["Mayotte", "Mayotte"]
        ],
        "DE": [
        ['', ''],
        ["Baden-Wuerttemberg", "Bade-Wurtemberg"],
        ["Bayern", "Bavière"],
        ["Berlin", "Berlin"],
        ["Brandenburg", "Brandebourg"],
        ["Bremen", "Brême"],
        ["Hamburg", "Hambourg"],
        ["Hessen", "Hesse"],
        ["Mecklenburg-Vorpommern", "Mecklembourg-Poméranie-Occidentale"],
        ["Niedersachsen", "Basse-Saxe"],
        ["Nordrhein-Westfalen", "Rhénanie-du-Nord-Westphalie"],
        ["Rheinland-Pfalz", "Rhénanie-Palatinat"],
        ["Saarland", "Sarre"],
        ["Sachsen", "Saxe"],
        ["Sachsen-Anhalt", "Saxe-Anhalt"],
        ["Schleswig-Holstein", "Schleswig-Holstein"],
        ["Thueringen", "Thuringe"]
        ],
        "ES": [
        ['', ''],
        ["ARABA/ÁLAVA", "Álava"],
        ["ALBACETE", "Albacete"],
        ["ALICANTE", "Alicante"],
        ["ALMERIA", "Almería"],
        ["AVILA", "Ávila"],
        ["BADAJOZ", "Badajoz"],
        ["ILLES BALEARS", "Îles Baléares"],
        ["BARCELONA", "Barcelone"],
        ["BURGOS", "Burgos"],
        ["CACERES", "Cáceres"],
        ["CADIZ", "Cadix"],
        ["CASTELLON", "Castellón"],
        ["CIUDAD REAL", "Ciudad Real"],
        ["CORDOBA", "Cordoue"],
        ["CORUÑA, A", "La Corogne"],
        ["CUENCA", "Cuenca"],
        ["GIRONA", "Girone"],
        ["GRANADA", "Grenade"],
        ["GUADALAJARA", "Guadalajara"],
        ["GIPUZKOA", "Guipuscoa"],
        ["HUELVA", "Huelva"],
        ["HUESCA", "Huesca"],
        ["JAEN", "Jaén"],
        ["LEON", "Léon"],
        ["LLEIDA", "Lleida"],
        ["RIOJA, LA", "La Rioja"],
        ["LUGO", "Lugo"],
        ["MADRID", "Madrid"],
        ["MALAGA", "Málaga"],
        ["MURCIA", "Murcie"],
        ["NAVARRA", "Navarre"],
        ["OURENSE", "Ourense"],
        ["ASTURIAS", "Asturies"],
        ["PALENCIA", "Palencia"],
        ["PALMAS, LAS", "Las Palmas"],
        ["PONTEVEDRA", "Pontevedra"],
        ["SALAMANCA", "Salamanque"],
        ["SANTA CRUZ DE TENERIFE", "Santa Cruz de Tenerife"],
        ["CANTABRIA", "Cantabrie"],
        ["SEGOVIA", "Ségovie"],
        ["SEVILLA", "Séville"],
        ["SORIA", "Soria"],
        ["TARRAGONA", "Tarragone"],
        ["TERUEL", "Teruel"],
        ["TOLEDO", "Tolède"],
        ["VALENCIA", "Valence"],
        ["VALLADOLID", "Valladolid"],
        ["BIZKAIA", "Biscaye"],
        ["ZAMORA", "Zamora"],
        ["ZARAGOZA", "Saragosse"],
        ["CEUTA", "Ceuta"],
        ["MELILLA", "Melilla"]
        ],
        "IN": [
        ['', ''],
        ["Andaman and Nicobar Islands", "Andaman et Nicobar"],
        ["Andhra Pradesh", "Andhra Pradesh"],
        ["Arunachal Pradesh", "Arunachal Pradesh"],
        ["Assam", "Assam"],
        ["Bihar", "Bihar"],
        ["Chandigarh", "Chandigarh"],
        ["Chhattīsgarh", "Chhattisgarh"],
        ["Dadra and Nagar Haveli and Daman and Diu", "Dadra et Nagar Haveli et Daman et Diu"],
        ["Delhi", "Delhi"],
        ["Goa", "Goa"],
        ["Gujarat", "Gujarat"],
        ["Haryana", "Haryana"],
        ["Himachal Pradesh", "Himachal Pradesh"],
        ["Jammu and Kashmir", "Jammu-et-Cachemire"],
        ["Jharkhand", "Jharkhand"],
        ["Karnataka", "Karnataka"],
        ["Kerala", "Kerala"],
        ["Ladakh", "Ladakh"],
        ["Lakshadweep", "Lakshadweep"],
        ["Madhya Pradesh", "Madhya Pradesh"],
        ["Maharashtra", "Maharashtra"],
        ["Manipur", "Manipur"],
        ["Meghalaya", "Meghalaya"],
        ["Mizoram", "Mizoram"],
        ["Nagaland", "Nagaland"],
        ["Odisha", "Odisha"],
        ["Puducherry", "Puducherry"],
        ["Punjab", "Pendjab"],
        ["Rajasthan", "Rajasthan"],
        ["Sikkim", "Sikkim"],
        ["Tamil Nadu", "Tamil Nadu"],
        ["Telangana", "Telangana"],
        ["Tripura", "Tripura"],
        ["Uttar Pradesh", "Uttar Pradesh"],
        ["Uttarakhand", "Uttarakhand"],
        ["West Bengal", "Bengale-Occidental"]
        ],
        "IT": [
        ['', ''],
        ["AG", "AG"],
        ["AL", "AL"],
        ["AN", "AN"],
        ["AO", "AO"],
        ["AR", "AR"],
        ["AP", "AP"],
        ["AQ", "AQ"],
        ["AT", "AT"],
        ["AV", "AV"],
        ["BA", "BA"],
        ["BT", "BT"],
        ["BL", "BL"],
        ["BN", "BN"],
        ["BG", "BG"],
        ["BI", "BI"],
        ["BO", "BO"],
        ["BZ", "BZ"],
        ["BS", "BS"],
        ["BR", "BR"],
        ["CA", "CA"],
        ["CL", "CL"],
        ["CB", "CB"],
        ["CI", "CI"],
        ["CE", "CE"],
        ["CT", "CT"],
        ["CZ", "CZ"],
        ["CH", "CH"],
        ["CO", "CO"],
        ["CS", "CS"],
        ["CR", "CR"],
        ["KR", "KR"],
        ["CN", "CN"],
        ["EN", "EN"],
        ["FM", "FM"],
        ["FE", "FE"],
        ["FI", "FI"],
        ["FG", "FG"],
        ["FC", "FC"],
        ["FR", "FR"],
        ["GE", "GE"],
        ["GO", "GO"],
        ["GR", "GR"],
        ["IM", "IM"],
        ["IS", "IS"],
        ["SP", "SP"],
        ["LT", "LT"],
        ["LE", "LE"],
        ["LC", "LC"],
        ["LI", "LI"],
        ["LO", "LO"],
        ["LU", "LU"],
        ["MB", "MB"],
        ["MC", "MC"],
        ["MN", "MN"],
        ["MS", "MS"],
        ["MT", "MT"],
        ["ME", "ME"],
        ["MI", "MI"],
        ["MO", "MO"],
        ["NA", "NA"],
        ["NO", "NO"],
        ["NU", "NU"],
        ["OT", "OT"],
        ["OR", "OR"],
        ["PD", "PD"],
        ["PA", "PA"],
        ["PR", "PR"],
        ["PV", "PV"],
        ["PG", "PG"],
        ["PU", "PU"],
        ["PE", "PE"],
        ["PC", "PC"],
        ["PI", "PI"],
        ["PT", "PT"],
        ["PN", "PN"],
        ["PZ", "PZ"],
        ["PO", "PO"],
        ["RG", "RG"],
        ["RA", "RA"],
        ["RC", "RC"],
        ["RE", "RE"],
        ["RI", "RI"],
        ["RN", "RN"],
        ["RM", "RM"],
        ["RO", "RO"],
        ["SA", "SA"],
        ["VS", "VS"],
        ["SS", "SS"],
        ["SV", "SV"],
        ["SI", "SI"],
        ["SR", "SR"],
        ["SO", "SO"],
        ["SU", "SU"],
        ["TA", "TA"],
        ["TE", "TE"],
        ["TR", "TR"],
        ["TO", "TO"],
        ["OG", "OG"],
        ["TP", "TP"],
        ["TN", "TN"],
        ["TV", "TV"],
        ["TS", "TS"],
        ["UD", "UD"],
        ["VA", "VA"],
        ["VE", "VE"],
        ["VB", "VB"],
        ["VC", "VC"],
        ["VR", "VR"],
        ["VS", "VS"],
        ["VV", "VV"],
        ["VI", "VI"],
        ["VT", "VT"]
        ],
        "NL": [
        ['', ''],
        ["Drenthe", "Drenthe"],
        ["Flevoland", "Flevoland"],
        ["Friesland", "Frise"],
        ["Gelderland", "Gueldre"],
        ["Groningen", "Groningue"],
        ["Limburg", "Limbourg"],
        ["Noord-Brabant", "Brabant-Septentrional"],
        ["Noord-Holland", "Hollande-Septentrionale"],
        ["Overijssel", "Overijssel"],
        ["Utrecht", "Utrecht"],
        ["Zeeland", "Zélande"],
        ["Zuid-Holland", "Hollande-Méridionale"]
        ],
        "NZ": [
        ['', ''],
        ["Northland", "Northland"],
        ["Auckland", "Auckland"],
        ["Waikato", "Waikato"],
        ["Bay of Plenty", "Baie de Plenty"],
        ["Gisborne", "Gisborne"],
        ["Hawkes Bay", "Hawke's Bay"],
        ["Taranaki", "Taranaki"],
        ["Manawatu-Wanganui", "Manawatu-Wanganui"],
        ["Wellington", "Wellington"],
        ["Tasman", "Tasman"],
        ["Nelson", "Nelson"],
        ["Marlborough", "Marlborough"],
        ["West Coast", "Côte Ouest"],
        ["Canterbury", "Canterbury"],
        ["Otago", "Otago"],
        ["Southland", "Southland"]
        ],
        "GB": [
        ["Avon", "Avon"],
        ["Aberdeenshire", "Aberdeenshire"],
        ["Angus", "Angus"],
        ["Argyll and Bute", "Argyll and Bute"],
        ["Barking and Dagenham", "Barking and Dagenham"],
        ["Barnet", "Barnet"],
        ["Barnsley", "Barnsley"],
        ["Bath and North East Somerset", "Bath et North East Somerset"],
        ["Bedfordshire", "Bedfordshire"],
        ["Berkshire", "Berkshire"],
        ["Bexley", "Bexley"],
        ["Birmingham", "Birmingham"],
        ["Blackburn with Darwen", "Blackburn with Darwen"],
        ["Blackpool", "Blackpool"],
        ["Blaenau Gwent", "Blaenau Gwent"],
        ["Bolton", "Bolton"],
        ["Bournemouth", "Bournemouth"],
        ["Bracknell Forest", "Bracknell Forest"],
        ["Bradford", "Bradford"],
        ["Brent", "Brent"],
        ["Bridgend", "Bridgend"],
        ["Brighton and Hove", "Brighton et Hove"],
        ["Bromley", "Bromley"],
        ["Buckinghamshire", "Buckinghamshire"],
        ["Bury", "Bury"],
        ["Caerphilly", "Caerphilly"],
        ["Calderdale", "Calderdale"],
        ["Cambridgeshire", "Cambridgeshire"],
        ["Camden", "Camden"],
        ["Cardiff", "Cardiff"],
        ["Carmarthenshire", "Carmarthenshire"],
        ["Ceredigion", "Ceredigion"],
        ["Cheshire", "Cheshire"],
        ["Cleveland", "Cleveland"],
        ["City of Bristol", "Ville de Bristol"],
        ["City of Edinburgh", "Ville d'Édimbourg"],
        ["City of Kingston upon Hull", "Ville de Kingston upon Hull"],
        ["City of London", "Ville de Londres"],
        ["Clackmannanshire", "Clackmannanshire"],
        ["Conwy", "Conwy"],
        ["Cornwall", "Cornouailles"],
        ["Coventry", "Coventry"],
        ["Croydon", "Croydon"],
        ["Cumbria", "Cumbria"],
        ["Darlington", "Darlington"],
        ["Denbighshire", "Denbighshire"],
        ["Derby", "Derby"],
        ["Derbyshire", "Derbyshire"],
        ["Devon", "Devon"],
        ["Doncaster", "Doncaster"],
        ["Dorset", "Dorset"],
        ["Dudley", "Dudley"],
        ["Dumfries and Galloway", "Dumfries et Galloway"],
        ["Dundee City", "Ville de Dundee"],
        ["Durham", "Durham"],
        ["Ealing", "Ealing"],
        ["East Ayrshire", "East Ayrshire"],
        ["East Dunbartonshire", "East Dunbartonshire"],
        ["East Lothian", "East Lothian"],
        ["East Renfrewshire", "East Renfrewshire"],
        ["East Riding of Yorkshire", "East Riding of Yorkshire"],
        ["East Sussex", "East Sussex"],
        ["Eilean Siar (Western Isles)", "Eilean Siar (Western Isles)"],
        ["Enfield", "Enfield"],
        ["Essex", "Essex"],
        ["Falkirk", "Falkirk"],
        ["Fife", "Fife"],
        ["Flintshire", "Flintshire"],
        ["Gateshead", "Gateshead"],
        ["Glasgow City", "Ville de Glasgow"],
        ["Gloucestershire", "Gloucestershire"],
        ["Greenwich", "Greenwich"],
        ["Gwynedd", "Gwynedd"],
        ["Hackney", "Hackney"],
        ["Halton", "Halton"],
        ["Hammersmith and Fulham", "Hammersmith et Fulham"],
        ["Hampshire", "Hampshire"],
        ["Haringey", "Haringey"],
        ["Harrow", "Harrow"],
        ["Hartlepool", "Hartlepool"],
        ["Havering", "Havering"],
        ["Herefordshire", "Herefordshire"],
        ["Hertfordshire", "Hertfordshire"],
        ["Highland", "Highland"],
        ["Hillingdon", "Hillingdon"],
        ["Hounslow", "Hounslow"],
        ["Inverclyde", "Inverclyde"],
        ["Isle of Anglesey", "Île d'Anglesey"],
        ["Isle of Wight", "Île de Wight"],
        ["Islington", "Islington"],
        ["Kensington and Chelsea", "Kensington et Chelsea"],
        ["Kent", "Kent"],
        ["Kingston upon Thames", "Kingston upon Thames"],
        ["Kirklees", "Kirklees"],
        ["Knowsley", "Knowsley"],
        ["Lambeth", "Lambeth"],
        ["Lancashire", "Lancashire"],
        ["Leeds", "Leeds"],
        ["Leicester", "Leicester"],
        ["Leicestershire", "Leicestershire"],
        ["Lewisham", "Lewisham"],
        ["Lincolnshire", "Lincolnshire"],
        ["Liverpool", "Liverpool"],
        ["London", "Londres"],
        ["Luton", "Luton"],
        ["Manchester", "Manchester"],
        ["Medway", "Medway"],
        ["Merthyr Tydfil", "Merthyr Tydfil"],
        ["Merton", "Merton"],
        ["Merseyside", "Merseyside"],
        ["Middlesbrough", "Middlesbrough"],
        ["Middlesex", "Middlesex"],
        ["Midlothian", "Midlothian"],
        ["Milton Keynes", "Milton Keynes"],
        ["Monmouthshire", "Monmouthshire"],
        ["Moray", "Moray"],
        ["Neath Port Talbot", "Neath Port Talbot"],
        ["Newcastle upon Tyne", "Newcastle upon Tyne"],
        ["Newham", "Newham"],
        ["Newport", "Newport"],
        ["Norfolk", "Norfolk"],
        ["North Ayrshire", "North Ayrshire"],
        ["North East Lincolnshire", "North East Lincolnshire"],
        ["North Lanarkshire", "North Lanarkshire"],
        ["North Lincolnshire", "North Lincolnshire"],
        ["North Somerset", "North Somerset"],
        ["North Tyneside", "North Tyneside"],
        ["North Yorkshire", "North Yorkshire"],
        ["Northamptonshire", "Northamptonshire"],
        ["Northumberland", "Northumberland"],
        ["North Humberside", "North Humberside"],
        ["Nottingham", "Nottingham"],
        ["Nottinghamshire", "Nottinghamshire"],
        ["Oldham", "Oldham"],
        ["Orkney Islands", "Îles Orcades"],
        ["Oxfordshire", "Oxfordshire"],
        ["Pembrokeshire", "Pembrokeshire"],
        ["Perth and Kinross", "Perth et Kinross"],
        ["Peterborough", "Peterborough"],
        ["Plymouth", "Plymouth"],
        ["Poole", "Poole"],
        ["Portsmouth", "Portsmouth"],
        ["Powys", "Powys"],
        ["Reading", "Reading"],
        ["Redbridge", "Redbridge"],
        ["Renfrewshire", "Renfrewshire"],
        ["Rhondda Cynon Taff", "Rhondda Cynon Taff"],
        ["Richmond upon Thames", "Richmond upon Thames"],
        ["Rochdale", "Rochdale"],
        ["Rotherham", "Rotherham"],
        ["Rutland", "Rutland"],
        ["Salford", "Salford"],
        ["Sandwell", "Sandwell"],
        ["Sefton", "Sefton"],
        ["Sheffield", "Sheffield"],
        ["Shetland Islands", "Îles Shetland"],
        ["Shropshire", "Shropshire"],
        ["Slough", "Slough"],
        ["Solihull", "Solihull"],
        ["Somerset", "Somerset"],
        ["South Ayrshire", "South Ayrshire"],
        ["South Humberside", "South Humberside"],
        ["South Gloucestershire", "South Gloucestershire"],
        ["South Lanarkshire", "South Lanarkshire"],
        ["South Tyneside", "South Tyneside"],
        ["Southampton", "Southampton"],
        ["Southend-on-Sea", "Southend-on-Sea"],
        ["Southwark", "Southwark"],
        ["South Yorkshire", "South Yorkshire"],
        ["St. Helens", "St. Helens"],
        ["Staffordshire", "Staffordshire"],
        ["Stirling", "Stirling"],
        ["Stockport", "Stockport"],
        ["Stockton-on-Tees", "Stockton-on-Tees"],
        ["Stoke-on-Trent", "Stoke-on-Trent"],
        ["Suffolk", "Suffolk"],
        ["Sunderland", "Sunderland"],
        ["Surrey", "Surrey"],
        ["Sutton", "Sutton"],
        ["Swansea", "Swansea"],
        ["Swindon", "Swindon"],
        ["Tameside", "Tameside"],
        ["Telford and Wrekin", "Telford et Wrekin"],
        ["The Scottish Borders", "The Scottish Borders"],
        ["The Vale of Glamorgan", "The Vale of Glamorgan"],
        ["Thurrock", "Thurrock"],
        ["Torbay", "Torbay"],
        ["Torfaen", "Torfaen"],
        ["Tower Hamlets", "Tower Hamlets"],
        ["Trafford", "Trafford"],
        ["Tyne and Wear", "Tyne and Wear"],
        ["Wakefield", "Wakefield"],
        ["Walsall", "Walsall"],
        ["Waltham Forest", "Waltham Forest"],
        ["Wandsworth", "Wandsworth"],
        ["Warrington", "Warrington"],
        ["Warwickshire", "Warwickshire"],
        ["West Midlands", "West Midlands"],
        ["West Dunbartonshire", "West Dunbartonshire"],
        ["West Lothian", "West Lothian"],
        ["West Sussex", "West Sussex"],
        ["West Yorkshire", "West Yorkshire"],
        ["Westminster", "Westminster"],
        ["Wigan", "Wigan"],
        ["Wiltshire", "Wiltshire"],
        ["Windsor and Maidenhead", "Windsor and Maidenhead"],
        ["Wirral", "Wirral"],
        ["Wokingham", "Wokingham"],
        ["Wolverhampton", "Wolverhampton"],
        ["Worcestershire", "Worcestershire"],
        ["Wrexham", "Wrexham"],
        ["York", "York"],
        ["Co. Antrim", "Co. Antrim"],
        ["Co. Armagh", "Co. Armagh"],
        ["Co. Down", "Co. Down"],
        ["Co. Fermanagh", "Co. Fermanagh"],
        ["Co. Londonderry", "Co. Londonderry"],
        ["Co. Tyrone", "Co. Tyrone"]
        ],
        "US": [
        ['', ''],
        ["Alabama", "Alabama"],
        ["Alaska", "Alaska"],
        ["Arizona", "Arizona"],
        ["Arkansas", "Arkansas"],
        ["California", "Californie"],
        ["Colorado", "Colorado"],
        ["Connecticut", "Connecticut"],
        ["Delaware", "Delaware"],
        ["District of Columbia", "District de Columbia"],
        ["Florida", "Floride"],
        ["Georgia", "Géorgie"],
        ["Hawaii", "Hawaï"],
        ["Idaho", "Idaho"],
        ["Illinois", "Illinois"],
        ["Indiana", "Indiana"],
        ["Iowa", "Iowa"],
        ["Kansas", "Kansas"],
        ["Kentucky", "Kentucky"],
        ["Louisiana", "Louisiane"],
        ["Maine", "Maine"],
        ["Maryland", "Maryland"],
        ["Massachusetts", "Massachusetts"],
        ["Michigan", "Michigan"],
        ["Minnesota", "Minnesota"],
        ["Mississippi", "Mississippi"],
        ["Missouri", "Missouri"],
        ["Montana", "Montana"],
        ["Nebraska", "Nebraska"],
        ["Nevada", "Nevada"],
        ["New Hampshire", "New-Hampshire"],
        ["New Jersey", "New Jersey"],
        ["New Mexico", "Nouveau-Mexique"],
        ["New York", "New York"],
        ["North Carolina", "Caroline du Nord"],
        ["North Dakota", "Dakota du Nord"],
        ["Ohio", "Ohio"],
        ["Oklahoma", "Oklahoma"],
        ["Oregon", "Oregon"],
        ["Pennsylvania", "Pennsylvanie"],
        ["Rhode Island", "Rhode Island"],
        ["South Carolina", "Caroline du Sud"],
        ["South Dakota", "Dakota du Sud"],
        ["Tennessee", "Tennessee"],
        ["Texas", "Texas"],
        ["Utah", "Utah"],
        ["Vermont", "Vermont"],
        ["Virginia", "Virginie"],
        ["Washington", "Washington"],
        ["West Virginia", "Virginie-Occidentale"],
        ["Wisconsin", "Wisconsin"],
        ["Wyoming", "Wyoming"]
        ],
        "XK": [
        ['', ''],
        ["Ferizaj", "Ferizaj"],
        ["Gjakova", "Gjakova"],
        ["Gjilan", "Gjilan"],
        ["Mitrovica", "Mitrovica"],
        ["Peja", "Peja"],
        ["Pristina", "Pristina"],
        ["Prizren", "Prizren"]
        ]
    },
    rebuild: function(data, name, niceName, type, input, parent, inputWindow) {
        if (!input || !input.length) return;

        const val = data ? data.value : undefined;
        const countrySelect = inputWindow.find('[data-name="'+data.country+'"]');
        const countryVal = countrySelect.val();

        const items = inputs.fn.state.data[countryVal];
        const response = {
            data: items
        }
        
        let selectData = input.data('data') || data;
        if (!selectData) return;
        selectData.oldValue = val;

        inputs.fn.select.update(input, selectData, data, response);
    }
}

inputs.types.state = function (data, name, niceName, type, input, parent, inputWindow) {
    inputs.types.select(data, name, niceName, type, input, parent, inputWindow);

    const countrySelect = inputWindow.find('[data-name="'+data.country+'"]');
    countrySelect.change(function() {
        inputs.fn.state.rebuild(data, name, niceName, type, input, parent, inputWindow);
    });
    setTimeout(function() {
        inputs.fn.state.rebuild(data, name, niceName, type, input, parent, inputWindow);
    }, 100);
    
    return data;
};
